/**
 * Extracts the line endpoints of a line-like element regardless of its type.
 * Rips & lintels (PositionForVertical) carry `start`/`end` directly, while
 * beams/columns/purlins/slab beams (ShapeObjectLine) carry them on `shape`.
 * Returns null for non line-like elements (e.g. walls, slabs).
 */
const getElementLineEndpoints = (
  element: ShapeObject | ShapeObjectLine | Rip | Lintel | undefined,
): { start: Point; end: Point } | null => {
  if (!element) return null
  if ('start' in element && 'end' in element && element.start && element.end) {
    return { start: element.start, end: element.end }
  }
  if ('shape' in element && element.shape && 'start' in element.shape && 'end' in element.shape) {
    return { start: element.shape.start, end: element.shape.end }
  }
  return null
}

export default getElementLineEndpoints
